const AdobeAnalytics = () => {
  // setup events to be filtered out
  const EVENTS_TO_IGNORE = [
    'A/B testing',
  ];

  const digitalDataDefaults = (countryCode) => ({
    page: {
      pageInfo: {
        country: countryCode || 'US',
      },
      attributes: {
        autotrack: false,
      },
      category: {
        businessUnit: 'Resy',
        primaryCategory: 'resy',
      },
    },
  });

  const getCurrentDigitalData = () => window.digitalData || digitalDataDefaults(window.countryCode);

  const event = (name, props = {}) => {
    if (!EVENTS_TO_IGNORE.includes(name)) {
      const currentDigitalData = getCurrentDigitalData();
      window.digitalData = {
        ...currentDigitalData,
        event: [{
          eventInfo: {
            eventAction: name,
            eventAsset: props.eventAsset || ' ',
            eventType: 'pageInteraction',
          },
        }],
      };
      window._satellite?.track('event'); // eslint-disable-line no-underscore-dangle
    }
  };

  const page = (location, referrer, metadata) => {
    const currentDigitalData = getCurrentDigitalData();
    const pageName = metadata.venueName
      ? `${metadata.pageName}|${metadata.venueName}` : metadata.pageName;
    window.digitalData = {
      ...currentDigitalData,
      page: {
        ...currentDigitalData.page,
        pageInfo: {
          country: window.countryCode || 'US',
          language: metadata.language, // eg 'en-us'
          pageName, // eg 'homepage'
        },
        // category: {
        //   subCategory1: "<Sub Category 1>", // optional location eg 'new-york-ny' or should it be the numeric code?
        // }
      },
    };
    window._satellite?.track('page'); // eslint-disable-line no-underscore-dangle
  };

  const marketingCustomPage = (args) => {
    if (!args[2] || !args[1]) return;
    const currentDigitalData = getCurrentDigitalData();
    const metadata = args[2];
    const { category, label } = args[1];

    const pageName = metadata.venueName ? `${metadata.pageName}|${metadata.venueName}` : metadata.pageName;
    window.digitalData = {
      ...currentDigitalData,
      page: {
        ...currentDigitalData.page,
        pageInfo: {
          country: window.countryCode || 'US',
          language: metadata.language, // eg 'en-us'
          pageName: `${pageName}|${category}|${label}`, // eg 'homepage'
        },
      },
    };
    window._satellite?.track('page'); // eslint-disable-line no-underscore-dangle
  };

  const purchase = () => {
    event('purchase');
  };

  return {
    event,
    page,
    purchase,
    marketingCustomPage,
  };
};

export default AdobeAnalytics();
